import { DropdownItem } from 'ui-components';
import { PlusIcon } from 'ui-components/dist/PlusIcon';

interface IAddToListDropdownItem {
  onClick: () => void;
}

export const AddToListDropdownItem: React.FC<IAddToListDropdownItem> = ({
  onClick,
}) => {
  return (
    <DropdownItem onClick={onClick} trackId="foam-talent-menu-add-to-list">
      <PlusIcon boxSize={4} />
      Add to a List
    </DropdownItem>
  );
};
